module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Purchase","amount":"Amount","createdAt":"Purchased"},"es":{"title":"Compra","amount":"Monto","createdAt":"Comprado"},"sw":{"title":"Ununuzi","amount":"Thamani","createdAt":"Imenunuliwa"}}')
  delete Component.options._Ctor
}
